import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGithub } from "@fortawesome/free-brands-svg-icons"
import { faLinkedin } from "@fortawesome/free-brands-svg-icons"
import { faXTwitter } from "@fortawesome/free-brands-svg-icons"
import { faEnvelope } from "@fortawesome/free-solid-svg-icons"

export default function Footer(){
    return(
        <footer className="flex cursor-pointer flex-col items-center justify-center pt-[50px]">
            <h1 className="connect rotate-[3deg] text-[30px] pb-[30px]">Let's connect !</h1>

            <section className="flex text-white expoSpace flex-row items-center justify-evenly grid grid-cols-1 sm:grid-cols-3 w-[100%]">
                <a 
                href="https://github.com/ibrahimSho31/" target="_blank"
                className="flex hover:opacity-70 text-[40px] text-[#d6d6d6] flex-row items-center justify-between bg-[#333]  h-[80px] px-[20px]">
                    <h1>Github</h1>
                    <FontAwesomeIcon icon={faGithub} style={{color: "#d6d6d6"}} />
                </a>

                <a
                href="https://www.linkedin.com/in/ibrahim-shokoya-85a032258/" target="_blank" 
                className="flex hover:opacity-70 text-[40px] text-[#cce4f0] flex-row items-center justify-between h-[80px] px-[20px] bg-[#0077b5]">
                    <h1>LinkedIn</h1>
                    <FontAwesomeIcon icon={faLinkedin} style={{color: "#cce4f0"}} />
                </a>

                <a 
                href="https://twitter.com/tolani_is?s=21&t=5kREoGoxMqsgn4YGzJUj4g" target="_blank"
                className="flex hover:opacity-70 text-[40px] text-[#d6d6d6] flex-row items-center justify-between h-[80px] px-[20px] bg-[black]">
                    <h1>X</h1>
                    <FontAwesomeIcon icon={faXTwitter} style={{color: "#d6d6d6"}} />
                </a>
            </section>
            <a className="flex flex-row items-center justify-center bg-[#10ba46] hover:opacity-70
            w-[100%] py-[20px] text-[#f5f5f5] text-[30px] cyborg uppercase"
            href="mailto:shokoyaomotolani@gmail.com"
            >
                <h1 className="pr-[20px]">send a mail</h1>
                <FontAwesomeIcon icon={faEnvelope} style={{color: "#d6d6d6"}} />
            </a>
            <section className="cyborg py-[10px] text-center text-[20px] sm:text-[30px] capitalize w-[100%] bg-[#1f2128] text-[#10ba45] flex flex-row items-center justify-center">
                <h1>Built from scratch by Ibrahim using React ©</h1>
            </section>
            
            
            
        </footer>
    )
}